var React = require('react');

function Grass (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"grass"),React.createElement("polygon",{"points":"-0.123 302 20.938 0.72 42 302 -0.123 302","style":{"fill":"#448b6f"},"key":1})]);
}

Grass.defaultProps = {"width":"42","height":"302","viewBox":"0 0 42 302"};

module.exports = Grass;

Grass.default = Grass;
